import React from 'react';
import FoxMark from './FoxMark';

const PrivacyPolicy: React.FC = () => {
  return (
    <main className="min-h-screen bg-[#fbf8ef] text-[#17251d]">
      <nav className="border-b border-[#2f4a37] bg-[#102319]">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-6">
          <a href="/" className="flex items-center gap-3 text-lg font-semibold text-[#fffdf7]">
            <FoxMark size="md" />
            AlgoFox
          </a>
          <div className="flex items-center gap-4">
            <a href="/about" className="hidden text-sm font-semibold text-[#dfe7d8] hover:text-white sm:inline">
              About
            </a>
            <a href="/" className="text-sm font-semibold text-[#f0d7a6] hover:text-white">
              Back home
            </a>
          </div>
        </div>
      </nav>

      <section className="mx-auto max-w-4xl px-6 py-14">
        <p className="text-sm font-bold uppercase tracking-[0.24em] text-[#c7652d]">Privacy Policy</p>
        <h1 className="mt-3 text-4xl font-semibold text-[#1f3428]">AlgoFox Privacy Policy</h1>
        <p className="mt-4 text-sm leading-6 text-[#60705c]">Last updated: July 10, 2026</p>

        <div className="mt-10 space-y-8 rounded-lg border border-[#d8decf] bg-white p-6 shadow-sm">
          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">Overview</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              AlgoFox is currently collecting emails for launch updates, product news, and early access information.
              This policy explains what information we collect and how we use it.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">Information We Collect</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              When you join the launch list, we collect your email address. We may also collect basic technical
              information such as signup source, referrer, browser user agent, timestamps, and server logs to help us
              understand whether the signup flow is working correctly and to prevent abuse.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">How We Use Information</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              We use your email address to send AlgoFox launch updates, early access notes, and related product
              communication. We use technical information to operate, debug, secure, and improve the site.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">Email Provider</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              We use Mailchimp to manage the launch list and send email updates. Your email address may be processed by
              Mailchimp for those purposes. Mailchimp emails include unsubscribe controls.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">Sharing</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              We do not sell your personal information. We may share information with service providers that help us run
              AlgoFox, such as hosting, database, analytics, and email providers, only as needed to operate the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">Your Choices</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              You can unsubscribe from launch emails using the unsubscribe link in Mailchimp emails. You can also contact
              us to ask for removal from the launch list.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">Changes</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              We may update this policy as AlgoFox develops. If the changes are material, we will update the date above
              and provide notice where appropriate.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1f3428]">Contact</h2>
            <p className="mt-3 leading-7 text-[#52614f]">
              Questions about this policy can be sent to the AlgoFox team through the contact channel listed on the
              website or by replying to an AlgoFox launch-list email.
            </p>
          </section>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
